import { usePageContext } from "vike-vue/usePageContext";

export function useAPI() {
  const pageContext = usePageContext()
  return pageContext.api
}
